import PolicySection from "./PrivacyPolicy";
import { Container, Grid, Typography, Box } from "@mui/material";
import Navbar from "../../User/Navbar";
import Footer from "./Footer";

const privacyPolicyData = [
  {
    title: "Introduction",
    content:
      "NG Tax Updates is a drive management application designed to help users access shared Google Drive folders and view company-marked calendar events.",
    icon: "FileText",
  },
  {
    title: "Information We Collect",
    content:
      "We collect and process data including Google Drive access, Google Calendar events, authentication information, and device-related information.",
    icon: "Database",
  },
  {
    title: "How We Use Your Information",
    content:
      "We use your data strictly to display shared folders, allow downloads, show company-marked calendar events, and ensure a secure user experience.",
    icon: "PieChart",
  },
  {
    title: "Data Sharing and Storage",
    content:
      "We do not store, sell, or share user data. All data processing happens directly between the user and Google services.",
    icon: "Shield",
  },
  {
    title: "Permissions Requested",
    content:
      "We request read-only access to Google Drive and Calendar, along with authentication to verify user identity.",
    icon: "Key",
  },
  {
    title: "Security Measures",
    content:
      "We implement OAuth 2.0 authentication, encrypted data transmission, and comply with Google's security policies.",
    icon: "Lock",
  },
  {
    title: "Your Choices and Rights",
    content:
      "You can revoke app permissions anytime via your Google Account settings. Contact us for further queries.",
    icon: "UserCheck",
  },
  {
    title: "Changes to this Policy",
    content:
      "This Privacy Policy may be updated periodically. Please review this page regularly for any changes.",
    icon: "RefreshCw",
  },
];

export default function PrivacyPolicy() {
  return (
    <>
      <Navbar />
      <Box
        sx={{
          minHeight: "100vh",
          background: "linear-gradient(to bottom, #EBF2FF, white)",
          paddingY: 2,
        }}
      >
        <Container sx={{ py: 8 }}>
          <Typography
            variant="h3"
            align="center"
            fontWeight="bold"
            color="#151C62"
            gutterBottom
            sx={{
              fontSize: {
                xs: "1.5rem",
                sm: "2rem",
                md: "2.5rem",
                lg: "2.5rem",
              },
              lineHeight: { xs: "1.3", sm: "1.4", md: "1.5", lg: "1.5" },
              maxWidth: { xs: "90%", sm: "80%", md: "70%" },
              mx: "auto",
            }}
          >
            Our Commitment to Your Privacy
          </Typography>

          <Typography
            variant="h6"
            align="center"
            color="textSecondary"
            sx={{
              maxWidth: "600px",
              mx: "auto",
              mb: 4,
              fontSize: {
                xs: "0.875rem",
                sm: "1rem",
                md: "1.125rem",
                lg: "1.25rem",
              },
              lineHeight: { xs: "1.4", sm: "1.5", md: "1.6" },
            }}
          >
            At Rohans Tax Service's , we take your privacy seriously. Our policy
            is designed to protect your information and ensure transparency in
            our practices.
          </Typography>
          <Grid container spacing={4}>
            {privacyPolicyData.map((section, index) => (
              <Grid item xs={12} md={6} lg={4} key={index}>
                <PolicySection {...section} index={index} />
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
      <Footer />
    </>
  );
}
